(function () {
  function formatMoney(cents) {
    try {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function getSelectedVariantId() {
    var input = document.querySelector('product-form-component input[name="id"]')
      || document.querySelector('form[action*="/cart/add"] input[name="id"]')
      || document.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  function addPriceToButton() {
    var button = document.querySelector('button[data-testid="standalone-add-to-cart"]');
    if (!button) return;

    fetch(window.location.pathname + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) return;

        var variantId = getSelectedVariantId();
        var variant = product.variants.find(function (v) { return String(v.id) === String(variantId); });
        var price = variant ? variant.price : product.price;

        if (typeof price !== 'number') return;

        var priceSpan = button.querySelector('.custom-atc-price');
        if (!priceSpan) {
          priceSpan = document.createElement('span');
          priceSpan.className = 'custom-atc-price';
          var addedSpan = button.querySelector('.add-to-cart__added');
          if (addedSpan) {
            addedSpan.insertAdjacentElement('beforebegin', priceSpan);
          } else {
            button.appendChild(priceSpan);
          }
        }
        priceSpan.textContent = ' - ' + formatMoney(price);
      })
      .catch(function () {
        // Fail silently — the button must keep working even if this fetch fails
      });
  }

  addPriceToButton();

  var target = document.querySelector('product-form-component') || document.querySelector('#MainContent');
  if (target) {
    var observer = new MutationObserver(function () {
      addPriceToButton();
    });
    observer.observe(target, { childList: true, subtree: true });
  }
})();

(function () {
  var SECTION_ID = 'shopify-section-template--19241406234722__product_list_dbPHLD';

  function getTimelineValue(slide) {
    var match = (slide.getAttribute('style') || '').match(/--slideshow-timeline:\s*([^;]+)/);
    return match ? match[1].trim() : null;
  }

  function initCarouselDots() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var section = document.getElementById(SECTION_ID);
    if (!section) return;
    if (section.querySelector('.custom-carousel-dots')) return;

    var scroller = section.querySelector('slideshow-slides');
    var slideshowContainer = section.querySelector('slideshow-container');
    if (!scroller || !slideshowContainer) return;

    // Only this carousel's own slides — never the per-product photo
    // galleries nested inside each product-card.
    var allSlides = scroller.querySelectorAll(':scope > slideshow-slide');
    if (!allSlides.length) return;

    var timelineOrder = [];
    var seen = {};
    allSlides.forEach(function (slide) {
      var t = getTimelineValue(slide);
      if (t && !seen[t]) {
        seen[t] = true;
        timelineOrder.push(t);
      }
    });
    timelineOrder.sort();

    if (!timelineOrder.length) return;

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'custom-carousel-dots';

    var dotByTimeline = {};
    timelineOrder.forEach(function (t) {
      var dot = document.createElement('span');
      dot.className = 'custom-carousel-dot';
      dotsWrap.appendChild(dot);
      dotByTimeline[t] = dot;
    });

    slideshowContainer.insertAdjacentElement('afterend', dotsWrap);

    function updateActiveDot() {
      var containerRect = slideshowContainer.getBoundingClientRect();
      var containerCenter = containerRect.left + containerRect.width / 2;

      var visibleSlides = scroller.querySelectorAll(':scope > slideshow-slide[aria-hidden="false"]');
      var closestTimeline = null;
      var closestDistance = Infinity;

      visibleSlides.forEach(function (slide) {
        var rect = slide.getBoundingClientRect();
        var slideCenter = rect.left + rect.width / 2;
        var distance = Math.abs(slideCenter - containerCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestTimeline = getTimelineValue(slide);
        }
      });

      if (closestTimeline && dotByTimeline[closestTimeline]) {
        Object.keys(dotByTimeline).forEach(function (t) {
          dotByTimeline[t].classList.remove('is-active');
        });
        dotByTimeline[closestTimeline].classList.add('is-active');
      }
    }

    updateActiveDot();

    var scrollTimer = null;
    scroller.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateActiveDot, 80);
    }, { passive: true });
  }

  initCarouselDots();

  var pageTarget = document.querySelector('#MainContent');
  if (pageTarget) {
    var pageObserver = new MutationObserver(function () {
      initCarouselDots();
    });
    pageObserver.observe(pageTarget, { childList: true, subtree: true });
  }
})();